<template>
    <footer class="footer"
            :class="{[`footer-${type}`]: type}"
            :data-background-color="backgroundColor">
        <div class="container">
            <nav>
                <ul>
                    <li>
                        <router-link to="/facility-refrigeration-controls">
                            Controls
                        </router-link>
                    </li>
                    <li>
                        <a href="https://gamsplus.com" target="_blank">
                            Monitoring
                        </a>
                    </li>
                    <li>
                        <router-link to="/facility-refrigeration-engineering">
                            Engineering
                        </router-link>
                    </li>
                    <li>
                        <a href="https://parts.electronictechcorp.com/">
                            Parts
                        </a>
                    </li>
                </ul>
            </nav>
            <div class="copyright">
                &copy; {{year}} Electronic Technologies Corp.
            </div>
            <div style="display:none;">
                <img src="img/monitor-gif.gif" width="1" height="1" border="0" alt="1"/>
            </div>


        </div>
    </footer>
</template>
<script>
  export default {
    props: {
      backgroundColor: String,
      type: String
    },
    data(){
      return {
        year: new Date().getFullYear()
      }
    }
  }
</script>
<style>
</style>
